let id = 0
/**
 * Generates incremental unique id.
 *
 * @param prefix - Optional prefix for the ID (default: 'id')
 * @returns A unique incremental ID string
 * @remarks Should be used client side only.
 * @category Utils
 */
export const getIdClient = (prefix = 'id') => `${prefix}-${++id}`
